import {theme, Typography} from 'antd';
import React, {Fragment} from 'react';
import {BackButtonWText} from 'Components';

interface IProps {
  image: string;
  data: any;
  resetAfterSubmitting?(): any;
  srId?: number | null;
}

// Matches the mockup's `.success-box` — a green success-tinted, rounded panel.
const SubmissionResult: React.FC<IProps> = (props) => {
  const {image, data, resetAfterSubmitting, srId} = props;
  const {token}: any = theme.useToken();

  return (
    <div style={{margin: 24, display: 'flex', flexDirection: 'column', minHeight: '40vh'}}>
      <div style={{position: 'absolute'}}>
        <BackButtonWText text={data.back_text} callback={resetAfterSubmitting} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 12,
            textAlign: 'center',
            maxWidth: 420,
            padding: 24,
            borderRadius: token.borderRadiusLG,
            backgroundColor: token.colorSuccessBg,
            color: token.colorSuccess,
          }}>
          <img src={image} alt="" style={{width: 40, height: 40}} />
          <Typography.Title level={5} style={{margin: 0, color: token.colorSuccess}}>
            {srId ? data.success_text : data.updated_text}
          </Typography.Title>
          {srId && (
            <Fragment>
              <Typography.Text style={{color: token.colorSuccess}}>
                <strong>{data.ticket_text} </strong>
                {srId}
              </Typography.Text>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubmissionResult;
